export const LEGAL = {
  entity: "A.BC.D.F.LLC",
  state: "New York",
  brand: "T.A.C.C. — Through Adversity Comes Change",
  site: "tacc.love",
  email: "richculmer@gmail.com",
  updated: "September 8, 2026",
};
